import { Link } from 'react-router-dom';

function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-100 text-gray-900 p-8 mt-[60px]">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-10">
        <h1 className="text-4xl font-bold text-center mb-8 text-black">Terms of Service</h1>
        <p className="mb-6 text-lg">
          Welcome to the Evidence Cleaning website. By browsing or using this website, you agree to comply with and be bound by these Terms of Service and our{' '}
          <Link to="/privacy-policy" className="text-blue-600 underline">
            Privacy Policy
          </Link>
          . If you disagree with any part of these terms, please do not use our website.
        </p>
        <p className="mb-6 text-lg">
          &quot;Evidence Cleaning,&quot; &quot;we,&quot; &quot;us,&quot; and &quot;our&quot; refer to the owner and operator of this website. &quot;You&quot; refers to a website visitor, customer, employee, independent contractor, or independent service professional, as applicable.
        </p>

        <div className="border-l-4 border-gray-400 pl-4 mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-black">Use of the Website</h2>
          <p className="mb-6 text-lg">
            The content of this website is provided for general information and use. It may be changed without notice.
          </p>
        </div>

        <div className="border-l-4 border-gray-400 pl-4 mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-black">Privacy Policy</h2>
          <p className="mb-4 text-lg">
            Our Privacy Policy explains how we collect, use, store, and protect information in connection with our website, cleaning services, appointment scheduling, customer support, workforce communications, and business operations.
          </p>
          <p className="mb-6 text-lg">
            By providing information to us, you represent that the information is accurate and that you are authorized to provide it.
          </p>
        </div>

        <div className="border-l-4 border-gray-400 pl-4 mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-black">User Obligations</h2>
          <p className="mb-4 text-lg">You must not misuse this website. You may not:</p>
          <ul className="list-disc pl-6 mb-6 text-lg space-y-2">
            <li>Commit or encourage a criminal offense;</li>
            <li>Transmit viruses, malware, or technologically harmful material;</li>
            <li>Attempt to gain unauthorized access to the website or related systems;</li>
            <li>Corrupt data or interfere with website functionality;</li>
            <li>Infringe another person&apos;s intellectual-property or privacy rights;</li>
            <li>Send unsolicited advertising or spam through our systems; or</li>
            <li>Use the website in any unlawful, abusive, or offensive manner.</li>
          </ul>
        </div>

        <div className="border-l-4 border-gray-400 pl-4 mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-black">SMS Terms and Conditions</h2>

          <h3 className="text-xl font-semibold mb-3 text-black">Program Name</h3>
          <p className="mb-6 text-lg">Evidence Cleaning SMS Communications</p>

          <h3 className="text-xl font-semibold mb-3 text-black">Program Description</h3>
          <p className="mb-4 text-lg">
            Evidence Cleaning operates informational, non-promotional SMS programs for customers, employees, independent contractors, and independent cleaning professionals who affirmatively agree to receive messages.
          </p>

          <h4 className="text-lg font-semibold mb-3 text-black">Customer messages may include:</h4>
          <ul className="list-disc pl-6 mb-6 text-lg space-y-2">
            <li>Appointment confirmations and reminders;</li>
            <li>Scheduling and rescheduling information;</li>
            <li>Arrival updates;</li>
            <li>Service-related questions;</li>
            <li>Payment or invoice information;</li>
            <li>Customer-support responses; and</li>
            <li>Other updates directly related to requested cleaning services.</li>
          </ul>

          <h4 className="text-lg font-semibold mb-3 text-black">Employee and independent service professional messages may include:</h4>
          <ul className="list-disc pl-6 mb-4 text-lg space-y-2">
            <li>Work schedules;</li>
            <li>Cleaning assignments;</li>
            <li>Assignment availability;</li>
            <li>Service addresses and arrival instructions;</li>
            <li>Gate codes or other access information;</li>
            <li>Schedule changes or cancellations;</li>
            <li>Arrival and completion confirmations;</li>
            <li>Requests for work-status updates;</li>
            <li>Safety or operational notices; and</li>
            <li>Support while a cleaning service is being performed.</li>
          </ul>
          <p className="mb-6 text-lg">
            Evidence Cleaning does not use the employee and independent service professional SMS program for marketing or promotional messages.
          </p>

          <h3 className="text-xl font-semibold mb-3 text-black">Consent</h3>
          <p className="mb-4 text-lg">
            SMS messages are sent only after the recipient provides affirmative consent through an applicable opt-in process.
          </p>
          <p className="mb-4 text-lg">
            Customers may opt in through a website form, written or electronic agreement, documented verbal consent, or another process that clearly discloses the Evidence Cleaning SMS program and requires affirmative agreement before messages are sent. Providing a telephone number or booking a service alone does not constitute consent to receive recurring SMS messages.
          </p>
          <p className="mb-4 text-lg">
            Employees and independent service professionals may opt in verbally during onboarding or through a written or electronic consent process. When verbal consent is used, an Evidence Cleaning representative reads the SMS disclosure, receives an affirmative response, and records the recipient&apos;s name, phone number, consent date, consent method, and the representative who collected consent.
          </p>
          <p className="mb-6 text-lg">
            Consent applies only to the message categories disclosed when consent is collected. Consent to receive SMS messages is not a condition of purchasing cleaning services. Workers who opt out should contact their manager to establish another approved method for receiving necessary work communications.
          </p>

          <h3 className="text-xl font-semibold mb-3 text-black">Message Frequency</h3>
          <p className="mb-6 text-lg">
            Message frequency varies based on appointments, work schedules, assignments, service changes, and the recipient&apos;s interactions with Evidence Cleaning.
          </p>

          <h3 className="text-xl font-semibold mb-3 text-black">Message and Data Rates</h3>
          <p className="mb-6 text-lg">
            Message and data rates may apply according to the recipient&apos;s mobile carrier and service plan.
          </p>

          <h3 className="text-xl font-semibold mb-3 text-black">Opt-Out Instructions</h3>
          <p className="mb-4 text-lg">
            Recipients may opt out at any time by replying <strong>STOP</strong>.
          </p>
          <p className="mb-4 text-lg">
            After receiving a valid opt-out request, Evidence Cleaning may send one final confirmation message. No additional SMS messages will be sent unless the recipient provides new consent.
          </p>
          <p className="mb-6 text-lg">
            Other supported opt-out keywords may include CANCEL, END, QUIT, UNSUBSCRIBE, or OPTOUT.
          </p>

          <h3 className="text-xl font-semibold mb-3 text-black">Help</h3>
          <p className="mb-2 text-lg">For assistance, reply <strong>HELP</strong> or contact:</p>
          <p className="mb-2 text-lg">Evidence Cleaning</p>
          <p className="mb-2 text-lg">
            Email:{' '}
            <a href="mailto:contact@worldwideevidence.com" className="text-blue-600 underline">
              contact@worldwideevidence.com
            </a>
          </p>
          <p className="mb-6 text-lg">
            Phone:{' '}
            <a href="tel:7255774523" className="text-blue-600 underline">
              (725)-577-4523
            </a>
          </p>

          <h3 className="text-xl font-semibold mb-3 text-black">Carrier Disclaimer</h3>
          <p className="mb-6 text-lg">
            Wireless carriers are not responsible for delayed or undelivered messages.
          </p>

          <h3 className="text-xl font-semibold mb-3 text-black">Privacy</h3>
          <p className="mb-4 text-lg">
            Evidence Cleaning does not sell, rent, transfer, or share mobile phone numbers, SMS opt-in information, or text-messaging consent with third parties or affiliates for marketing or promotional purposes. This information will not be transferred to any external organization for marketing or promotional use. We may disclose information to service providers solely when necessary to operate our communications and services, provided they are prohibited from using it for their own marketing purposes.
          </p>
          <p className="mb-6 text-lg">
            Please review our{' '}
            <Link to="/privacy-policy" className="text-blue-600 underline">
              Privacy Policy
            </Link>{' '}
            for more information about how we handle personal information.
          </p>
        </div>

        <div className="border-l-4 border-gray-400 pl-4 mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-black">Appointment Confirmations by SMS and Phone</h2>
          <p className="mb-4 text-lg">
            Customers who affirmatively consent to appointment-related communications may receive SMS messages concerning booking confirmations, reminders, scheduling changes, service updates, and responses to inquiries.
          </p>
          <p className="mb-6 text-lg">
            When a customer calls Evidence Cleaning, we may discuss and confirm the customer&apos;s appointment and related service information during that call.
          </p>
        </div>

        <div className="border-l-4 border-gray-400 pl-4 mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-black">Photos and Videos of Services</h2>
          <p className="mb-4 text-lg">
            By engaging our services, you acknowledge that Evidence Cleaning may photograph or record its staff while cleaning services are being performed, where permitted and appropriately disclosed.
          </p>
          <p className="mb-6 text-lg">
            Media intended for our website, social media, training, or promotional channels will focus on our staff and the quality of the services provided. We will not intentionally disclose personal or sensitive information concerning customers or their properties without appropriate authorization.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
